export default {
  store: {
    DealerCode: 'Dealer Code',
    DealerName: 'Dealer Name',
    StoreType: 'Cooperative Product',
    StoreCode: 'Store Code',
    StoreName: 'Store Name',
    Province: 'Province',
    City: 'City',
    Area: 'Area',
    Address: 'Address',
    Salesman: 'Salesman Manager',
    SalesManName: 'SalesMan Name',
    SalesManId: 'SalesMan Id',
    ModifySalesman: 'Modify Salesman',
    ChooseSalesmanFirst: 'Choose Salesman First',
    Region: 'Region',
    Mobile: 'Mobile',
    ChooseRegionFirst: 'Choose Region First',
    ChooseStore: 'Choose Store',
    HaveTheIntention: 'Have The Intention',
    NotCooperating: 'Not Cooperating',
    TerminationOfCooperation: 'Termination Of Cooperation',
    Cooperationing: 'Cooperationing',
    CouponStatus: 'Coupon Status',
    CanSend: 'Can Send',
    CanNotSend: 'Can Not Send',
    OnlyOne: 'Only One Salesman'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/cmc/store.js